module.exports = __webpack_public_path__ + "assets/img/15.220d29f0.png";